// YesNoToggle.tsx
import { useEffect, useState } from 'react';
import './toogle.scss';

type SlideToggleProps = {
  onToggle: (isChecked: boolean) => void;
  name: string; // Adicionando uma propriedade 'name' para identificação
  className?: string;
  color?: string;
  initialState?: boolean;
}

export default function SlideToggle({ onToggle, name, color = '#4CAF50', className, initialState = false }: SlideToggleProps) {
  const [isChecked, setIsChecked] = useState(initialState);

  useEffect(() => {
    setIsChecked(initialState);
  }, [initialState]);

  const handleToggle = () => {
    const newIsChecked = !isChecked;
    setIsChecked(newIsChecked);
    onToggle(newIsChecked);
  };

  return (
    <div className={`toggle-switch ${className || ''}`.trim()}>
      <input type="checkbox" id={name} className="checkbox" checked={isChecked} onChange={handleToggle} />
      <label
        htmlFor={name}
        className="toggle-label"
        style={{ backgroundColor: isChecked ? color : '#ccc' }} // Apply dynamic color
      >
        <span className="toggle-inner"></span>
        <span className="toggle-switch"></span>
      </label>
    </div>
  );
}

